module.exports = __webpack_public_path__ + "static/Princetemon-675f5cee90ed36d05f8ab80d02b8872f.gif";